import menu from "constants/menu.json";
import { useNavigatePage } from "hooks/useNavigatePage";
import { useState } from "react";
import { useSelector } from "react-redux";
import { selectLanguage } from "redux/reducers/languageReducer";
import { Content, Menu, PcMenu, SideMenu, SideMenuContainer, SideMenuWrapper } from "./style";

const PcMenuCom = () => {
  const nav = useNavigatePage();
  const [hoverTopId, setHoverTopId] = useState(null);
  const [hoverIndex, setHoverIndex] = useState(null);
  const [isHover, setIsHover] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const isSelected = isHover || isClicked;
  const topMenuHoverHandler = (topId, topIndex) => {
    setHoverIndex(topIndex);
    setHoverTopId(topId);
    setIsHover(true);
  };

  // 라우터 관련
  const navHandler = (to) => {
    setIsHover(false);
    setIsClicked(false);
    nav(to);
  };

  // 메뉴 hover 관련
  const hoverLeaveHandler = () => {
    setIsHover(false);
  };

  // 언어 관련
  const currentLanguage = useSelector(selectLanguage);

  return (
    <>
      {
        <Content>
          <PcMenu onMouseLeave={hoverLeaveHandler}>
            {menu.data.map((top, idx) => (
              <div key={top.id}>
                <Menu
                  onMouseEnter={() => topMenuHoverHandler(top.id, top.menuIndex)}
                  onClick={() => setIsClicked(!isClicked)}
                  isSelected={isSelected && top.id === hoverTopId}
                >
                  <div>{currentLanguage === "en" ? top.title : top.titleKR}</div>
                  {idx === hoverIndex && isHover ? (
                    <img loading="lazy" src="/assets/img/Header_9.svg" alt="menuSlideImg" />
                  ) : (
                    <img loading="lazy" src="/assets/img/Header_5.svg" alt="menuSlideImg" />
                  )}
                </Menu>
                {idx === hoverIndex && isHover && (
                  <SideMenuWrapper>
                    <SideMenuContainer>
                      {top.sideMenus.map((side) => {
                        if (side.status)
                          return (
                            <SideMenu key={side.id} onClick={() => navHandler(side.url)}>
                              <div>{currentLanguage === "en" ? side.title : side.titleKR}</div>
                            </SideMenu>
                          );
                      })}
                    </SideMenuContainer>
                  </SideMenuWrapper>
                )}
              </div>
            ))}
          </PcMenu>
        </Content>
      }
    </>
  );
};

export default PcMenuCom;
